import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { LinkPrimitive } from '../link-primitive/link-primitive.js';
import * as button_module from '../buttons/button.module.css.js';
import { buttonText, buttonContent, button, icon } from '../buttons/button.module.css.js';
import { link } from './link-button.css.js';

// NOTE: LinkButton is not exported directly from FPL, but instead assigned as a `Button`
// property of our `<Link>` component. So it can be used as `<Link.Button>`.
/**
 * A link that is styled to look like a button.
 *
 * @see https://fpl.figma.design/components/links/link-button/
 */
const LinkButton = forwardRef(({ children, iconPrefix, variant = 'primary', size = 'md', width = 'hug', ...props }, ref) => {
    return (jsx(LinkPrimitive, { "data-fpl-component": "", ...props, ref: ref, "data-show-focus": true, className: clsx(link, button, button_module[variant], button_module[size], button_module[width]), children: jsxs("span", { className: buttonText, children: [iconPrefix && jsx(Icon, { children: iconPrefix }), jsx("span", { className: buttonContent, children: children })] }) }));
});
LinkButton.displayName = 'LinkButton';
// eslint-disable-next-line react/display-name
function Icon({ children }) {
    return (jsx("span", { "aria-hidden": true, className: icon, children: children }));
}

export { LinkButton };
//# sourceMappingURL=link-button.js.map
